import Splide from "@splidejs/splide";

export default class AutoSplide extends HTMLDivElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.splide = new Splide(this);
        this.splide.mount();
    }

}